import React, { useContext } from "react";
import axios from "axios";
import { ContentContext } from "../context/ContentContext";
import { UserContext } from "../context/UserContext";
import {
  Box,
  Heading,
  Text,
  Center,
  ButtonGroup,
  Button,
  Link,
  Image,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  useToast,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

const GameList = () => {
  const { games, fetch, setFetch } = useContext(ContentContext);
  const { user } = useContext(UserContext);
  const toast = useToast();
  const history = useHistory();

  const handleDelete = (event) => {
    event.preventDefault();
    let id = event.target.value;
    axios
      .delete(`https://backendexample.sanbersy.com/api/data-game/${id}`, {
        headers: { Authorization: "Bearer " + user.token },
      })
      .then(() => {
        toast({
          title: "Delete success",
          position: "top",
          status: "success",
          duration: 1500,
        });
        setFetch(!fetch);
      });
  };

  const handleEdit = (event) => {
    let id = event.target.value;
    console.log(event.target.value);
    history.push(`/game/edit/${id}`);
  };

  return (
    <Box p={4}>
      <Center>
        <Heading as="h1" size="xl">
          Game List
        </Heading>
      </Center>
      <Button
        colorScheme="teal"
        variant="solid"
        onClick={() => history.push("/game/create")}
      >
        Add Game
      </Button>
      <Table variant="simple" m={4}>
        <TableCaption>Game List</TableCaption>
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>Name</Th>
            <Th>Genre</Th>
            <Th>Release Year</Th>
            <Th>Platform</Th>
            <Th>Single Player</Th>
            <Th>Multi Player</Th>
            <Th>Image</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {games ? (
            games.map((data, index) => {
              return (
                <Tr key={index}>
                  <Td>{data.index}</Td>
                  <Td>{data.name}</Td>
                  <Td>{data.genre}</Td>
                  <Td>{data.release}</Td>
                  <Td>{data.platform}</Td>
                  <Td>{data.singlePlayer ? "Yes" : "No"}</Td>
                  <Td>{data.multiPlayer ? "Yes" : "No"}</Td>
                  <Td>
                    <Image
                      boxSize="200px"
                      objectFit="cover"
                      loading="lazy"
                      src={data.image}
                      alt={data.title}
                    />
                  </Td>
                  <Td>
                    <ButtonGroup variant="outline" spacing="4">
                      <Button
                        colorScheme="teal"
                        onClick={handleEdit}
                        value={data.id}
                      >
                        Edit
                      </Button>
                      <Button
                        colorScheme="red"
                        onClick={handleDelete}
                        value={data.id}
                      >
                        Delete
                      </Button>
                    </ButtonGroup>
                  </Td>
                </Tr>
              );
            })
          ) : (
            <Tr>
              <Td>Data not available</Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </Box>
  );
};

export default GameList;
